import React from 'react';
import styled from 'styled-components';
import Button from '@zocdoc-frontend-common/components-button/Button';
import Checkbox from '@zocdoc-frontend-common/components-checkbox';
import Modal from '@zocdoc-frontend-common/components-modal';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import PasswordRules from '../../../../PasswordRules/PasswordRules';
import { passwordField, rememberMeField } from '../../../constants';
import PasswordField from './PasswordField';

/**
 * @param {function(): void} onChange
 * @param {function(): void} onCloseModal
 * @param {function(): void} onFocus
 * @param {function(): void} onSubmit
 * @param {boolean} showRememberMe
 * @param {Object} statusChecks
 * @returns {JSX.Element}
 * @constructor
 */
export default class PasswordFieldWithModal extends React.Component {
    render() {
        const {
            onChange,
            onCloseModal,
            onFocus,
            showRememberMe,
            statusChecks,
        } = this.props;

        return (
            <Modal onClickCancel={onCloseModal}>
                <StyledTitle>{`Create a password to continue`}</StyledTitle>
                <PasswordField
                    onChange={(e) => onChange(passwordField, e.target.value)}
                    onFocus={() => onFocus(passwordField)}
                    showRememberMe={showRememberMe}
                    statusChecks={statusChecks}
                    showStatusChecks={true}
                />
                <PasswordRules statusChecks={statusChecks} />
                {this.renderKeepMeSignedIn()}
                {this.renderContinue()}
            </Modal>
        );
    }

    renderKeepMeSignedIn = () => {
        const { onChange, showRememberMe } = this.props;
        if (showRememberMe) {
            return (
                <KeepMeSignedInWrapper>
                    <StyledCheckbox
                        checked
                        data-test="remember-me-checkbox"
                        data-uem-id="remember-me-checkbox"
                        onChange={(e) => {
                            onChange(rememberMeField, e.target.checked);
                        }}
                    />
                    Keep me signed in
                </KeepMeSignedInWrapper>
            );
        }
    };

    renderContinue = () => {
        const { onSubmit } = this.props;

        return (
            <ContinueButton
                data-test="modal-submit-button"
                data-uem-id="modal-submit-button"
                onClick={onSubmit}
            >
                Continue
            </ContinueButton>
        );
    };
}

const StyledTitle = styled.h2`
    font: 20px/1.4 ${FontFamily.SharpSansBold};
    margin-bottom: 17px;
`;

const KeepMeSignedInWrapper = styled.div`
    display: flex;
    align-items: center;
    font: 15px/1.33 ${FontFamily.SharpSansMedium};
    margin-top: 16px;
    padding-left: 0;
`;

const StyledCheckbox = styled(Checkbox)`
    padding-left: 0;
`;

const ContinueButton = styled(Button)`
    margin-top: 16px;
    width: 100%;
    ${breakpoint.medium} {
        width: auto;
    }
`;
